import React, {Suspense} from 'react'
import './css/App.css'
import BoothLayout from "./components/BoothLayout"
import SplashPage from "./components/pages/SplashPage"
import CameraPage from "./components/pages/CameraPage"
import CameraErrorFallbackPage from "./components/pages/CameraErrorFallbackPage"
import EditPage from "./components/pages/EditPage"
import WrapUpPage from "./components/pages/WrapUpPage"
import GuestInputPage from "./components/pages/GuestInputPage"
import PicPage from "./components/pages/PicPage"
import {BrowserRouter as Router, Route, Routes} from "react-router-dom"
import {API} from "@simplebooth/webkit"
import PageNotFound from './components/views/PageNotFound'

function App() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL as string
  API.configure(baseUrl)

  return (
    <>
      <link
        rel="stylesheet"
        crossOrigin="anonymous"
        href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
        integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
      />
      <link rel="stylesheet" type="text/css" href="https://cloud.typography.com/6633494/6612752/css/fonts.css"/>
      <Suspense fallback="loading">
        <Router>
          <Routes>
            <Route element={<BoothLayout/>}>
              <Route path="/:code" element={<SplashPage/>}/>
              <Route path="/:code/camera" element={<CameraPage/>}/>
              <Route path="/:code/camera-fallback" element={<CameraErrorFallbackPage/>}/>
              <Route path="/:code/guest-input" element={<GuestInputPage/>}/>
              <Route path="/:code/edit" element={<EditPage/>}/>
              <Route path="/:code/wrap-up" element={<WrapUpPage/>}/>
              <Route path="/:code/pic/:uploadCode" element={<PicPage/>}/>
              <Route path="/:code/pic/:uploadCode/:picPresentation" element={<PicPage/>}/>
            </Route>
            <Route path="*" element={<PageNotFound/>}/>
          </Routes>
        </Router>
      </Suspense>
    </>
  )
}

export default App
